define('auiConfig',['mainCons'], function (mainCons) {
    return function ($auiInitProvider) {
        $auiInitProvider.initConfig({
            language: 'zh',
            auiDialog: {
                filterXss: true
            },
            auiUpload: {
                openApp: sysUrlCfg.url.contentServer,
                openUP: sysUrlCfg.url.authContentServer,
                devEco: sysUrlCfg.url.testCenterFileServer
            },
            auiPdf: {
                pdfPath: "../refactor/vendors/pdfjs-dist"
            },
            auiAgreementHelper: {
                isNeedPrivacyPolicySign: true
            },
            auiAjaxWithError: {
                zhConst: 'HuaweiError'
            },
            auiBalanceConstant: {
                auiCurrencyRate: mainCons.balanceConstant.CurrencyRate
            },
            pay: {
                notify_url: sysUrlCfg.pay.notify_url,
                requestUrl: sysUrlCfg.pay.requestUrl,
                payVersion: sysUrlCfg.pay.payVersion,
                payContractEffDate: sysUrlCfg.pay.payContractEffDate
            },
            splitUploadParam: sysParamCfg.chunkUpload,
            documentHref: {
                payAgreementUrl: sysUrlCfg.documentHref.payAgreementUrl
            },
            hifiPath: "vendors/ucd/resources/default/",
            appPromotion: sysParamCfg.appPromotion
        });
        // 登录页面的语言，默认中文
        sysUrlCfg.oAuthConfig.loginLanguage = 'zh';
        // 网关信息
        AUI.initConfig({
            HDGWCall: angular.extend(sysUrlCfg.oAuthConfig, {
                externalHeaders: function () {
                    var headers = {};
                    if (sessionStorage.getItem('x-uid') && sysUrlCfg.oAuthConfig.isSetXUid) {
                        headers['x-uid'] = sessionStorage.getItem('x-uid');
                    }
                    if (sessionStorage.getItem('x-country')) {
                        headers['x-country'] = sessionStorage.getItem('x-country');
                    }
                    if (sessionStorage.getItem('x-userType')) {
                        headers['x-userType'] = sessionStorage.getItem('x-userType');
                    }
                    if (localStorage.getItem('X-HD-SESSION')) {
                        headers['X-HD-SESSION'] = localStorage.getItem('X-HD-SESSION');
                    }

                    return headers;
                }
            }),
            accountDisable: sysUrlCfg.user.accountDisable,
            userPrivacyPolicy: sysUrlCfg.userPrivacyPolicy,
            indexUrlPath: sysUrlCfg.user.indexUrl,
            notSetUserIDArray: ["OpenUP.Server4User.updateDeveloper", "OpenUP.Server4User.submitPayVerify", "OpenUP.Server4User.getUserRouteInfo",
                "OpenUP.Server4User.checkTeamMember", "OpenUP.Server4User.setLoginTime", "EOpenUP.Server4User.getUserRouteInfo",
                "OpenUP.Server4User.getRuUserAuthInfo"],
            authUrl: sysUrlCfg.authUrl,
            specUrls: ["OpenTrade.Server4User.getEdmAttachment", "OpenTrade.Server4User.getAttachment"],
            siteIDToZoneID: sysUrlCfg.siteIDToZoneID,
            purviewLimitsInterface: sysParamCfg.purviewLimitsInterface,
            resignAgreementsNew: sysParamCfg.resignAgreementsNew,
            loginUpdateLoginChannelByHash: sysParamCfg.loginUpdateLoginChannelByHash,
            //只有opencommon.DelegateTm的
            handleByChinaInterface: ["OpenUP.Server4User.getUserRouteInfo"],
            handleSpecialInterfaceForTimeOut: sysParamCfg.handleSpecialInterfaceForTimeOut,
            //前台的开关直接放这里
            switchConf: sysParamCfg.switchConf,
            agcTeamRoleToID: sysParamCfg.agcTeamRoleToID,
            agreementReSignFaq: sysParamCfg.agreementReSignFaq,
            handleByRuPersonInterface: sysParamCfg.handleByRuPersonInterface,
            handleByChinaNotDelegateInterface: sysParamCfg.handleByChinaNotDelegateInterface,
            zoneIDToSiteIDMap: sysUrlCfg.zoneIDToSiteIDMap,
            esdkHelpAgreement: sysParamCfg.esdkHelpAgreement,
            teamAccountAgreement: '1053',
            displayCNCountries: sysParamCfg.displayCNCountries,
            isNeedParseStringInterfaces: sysParamCfg.isNeedParseStringInterfaces,
            businessType: sysParamCfg.businessType,
            teamAccountInvalidUrl: sysParamCfg.bankServiceLink,
            whiteListUrl: sysParamCfg.whiteListUrl,
            onlineWhiteOriginUrl: sysUrlCfg.onlineWhiteOriginUrl,
            originalDomainSwitchObject: sysUrlCfg.originalDomainSwitchObject['china']//国内的就取中国的
        });
    }
});

